export class NativeStandardBackupSchedules {
    'targetRegion';
    'scheduleConfig';
    'backupRetentionDays';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "targetRegion",
            "baseName": "targetRegion",
            "type": "string",
            "format": ""
        },
        {
            "name": "scheduleConfig",
            "baseName": "scheduleConfig",
            "type": "StandardBackupScheduleConfig",
            "format": ""
        },
        {
            "name": "backupRetentionDays",
            "baseName": "backupRetentionDays",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStandardBackupSchedules.attributeTypeMap;
    }
    constructor() {
    }
}
